import styled from 'styled-components';
import { breakpointDown } from 'styles/breakpoints';

export const ProgressBarTitleContainer = styled.div`
    h1 {
        transition: opacity 0.2s ease-in-out;

        ${breakpointDown.md`
            font-size: 24px;
        `};
    }

    .about-wellbeing,
    .about-wealth,
    .question-one,
    .question-two,
    .question-three,
    .question-four,
    .question-five,
    .question-six,
    .question-twelve,
    .question-thirteen,
    .question-fourteen,
    .question-fifteen,
    .question-sixteen,
    .question-seventeen,
    .question-eighteen {
        transition: opacity 0.2s ease-in-out;
        opacity: 0.6;
    }
`;

export const ProgressBarWorklifeStyles = styled.div`
    height: 8px;
    background-color: ${({ theme }) => theme.colors.lightcoral};
    border-left: 1px solid ${({ theme }) => theme.colors.eggshell};
    border-right: 1px solid ${({ theme }) => theme.colors.eggshell};
`;

export const ProgressBarLoader = styled.div`
    span {
        display: block;
        width: 0;
        height: 8px;
        background-color: ${({ theme }) => theme.colors.coral};
        transition: width 0.2s ease-in;

        &.question-two,
        &.question-thre,
        &.question-four,
        &.question-five,
        &.question-six,
        &.question-seven {
            width: 0;
        }

        &.question-eight {
            width: calc((100% / 5));
        }
        &.question-nine {
            width: calc((100% / 5) * 2);
        }
        &.question-ten {
            width: calc((100% / 5) * 3);
        }
        &.question-eleven {
            width: calc((100% / 5) * 4);
        }
        &.question-twelve {
            width: calc((100% / 5) * 5);
        }

        &.about-wealth,
        &.question-thirteen,
        &.question-fourteen,
        &.question-fifteen,
        &.question-sixteen,
        &.question-seventeen,
        &.question-eighteen {
            width: 100%;
        }
    }
`;
